<template>
  <div class="chart">
    <vue-apex-chart type="pie" :options="options" :series="series"/>
  </div>
</template>
<script>
  import map from 'lodash/map'
  import keys from 'lodash/keys'
  import VueApexChart from 'vue-apexcharts'
  import {formatRegularNumber, formatRaeNumber} from 'ncs/js/numbers'
  import {locales} from '../apexcharts_locales'

  export default {
    components: {VueApexChart},
    props: {
      i18nKeyPrefix: {type: String, required: true},
      data: {type: Object, required: true},
      precision: {type: Number, required: true},
      delimiter: {type: String, required: true},
      separator: {type: String, required: true},
    },
    computed: {
      categories() {
        return keys(this.data)
      },
      translatedCategories() {
        return this.categories.map(c => this.$t(`${this.i18nKeyPrefix}.${c}`))
      },
      series() {
        return map(this.categories, c => this.data[c] || 0)
      },
      options() {
        return {
          labels: this.translatedCategories,
          tooltip: {
            y: {
              formatter: this.formatNumber,
              title: {formatter: _seriesName => ''},
            }
          },
          chart: {
            locales,
            defaultLocale: this.$i18n.locale,
            toolbar: {show: true},
          },
          theme: {
            monochrome: {
              enabled: true,
              color: '#008751',
              shadeIntensity: 0.9
            }
          }
        }
      }
    },
    methods: {
      formatNumber(number) {
        const options = {delimiter: this.delimiter, separator: this.separator, precision: this.precision}
        if (this.$i18n.locale === 'es' || this.$i18n.locale === 'gl') {
          return formatRaeNumber(number, this.$i18n.locale, options)
        } else {
          return formatRegularNumber(number, this.$i18n.locale, options)
        }
      }
    }
  }
</script>
<style lang="scss">
  // See: https://github.com/apexcharts/apexcharts.js/issues/2313
  .apexcharts-menu-item.exportCSV { display: none; }
</style>
